module.exports = __webpack_public_path__ + "img/csgo.d9233352.png";